import React from "react";

import { Alert } from "@mui/material";

export interface PipelineErrorBannerProps {
  retryError: string | null;
  forceFailError: string | null;
  redeployError: string | null;
  onClearRetryError: () => void;
  onClearForceFailError: () => void;
  onClearRedeployError: () => void;
}

export function PipelineErrorBanner({
  retryError,
  forceFailError,
  redeployError,
  onClearRetryError,
  onClearForceFailError,
  onClearRedeployError,
}: PipelineErrorBannerProps): React.ReactElement | null {
  return (
    <>
      {retryError && (
        <Alert severity="error" onClose={onClearRetryError}>
          {retryError}
        </Alert>
      )}
      {forceFailError && (
        <Alert severity="error" onClose={onClearForceFailError}>
          {forceFailError}
        </Alert>
      )}
      {redeployError && (
        <Alert severity="error" onClose={onClearRedeployError}>
          {redeployError}
        </Alert>
      )}
    </>
  );
}
